import { type RequestPayload, router } from "@inertiajs/core";
import { CompanyForm } from "../../components/company/CompanyForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import { companies_path } from "../../routes";

export default function CompanyCreate() {
  const { pathWithYearContext } = useYearContext();

  const newCompany = (values: RequestPayload) => router.post(pathWithYearContext(companies_path), values);
  return (
    <ContentShell title="Neuer Lehrbetrieb" onBack={() => router.get(pathWithYearContext(companies_path))}>
      <CompanyForm submitButtonLabel="Erstellen" onSubmit={newCompany} />
    </ContentShell>
  );
}
